import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import { useNavigate } from 'react-router-dom';
import { dbPost } from '../../apis/commonApi';
import { NumericFormat } from 'react-number-format';
import { isValidEmail } from '../../services/UtilService';
import MemberController from '../../controllers/member/MemberController';

const UserInfoPswdChk = () => {
  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const [valueObj, setValueObj] = useState(null);
  const [formData, setFormData] = useState({});

  const controller = useMemo(() => {
    return new MemberController(
      { store, updateStore },
      modalService,
      validateService,
      navigate,
      [gridRef],
      {
        valueObj,
        setValueObj,
      }
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    if (store) {
      setFormData(prevFormData => ({
        ...prevFormData,
        userId: store.userId || '',
        userType: store.userType || '',
      }));
    }
  }, [store]);

  const userInfoPswdChk = () => {
    const url = '/member/userInfoPswdChk.do';
    const param = formData;
    if (formData.userPswd.length >= 8) {
      dbPost(url, param)
        .then(response => {
          if (response && formData.userType == 'U') {
            navigate('/member/userInfo/userInfo');
          } else if (response && formData.userType == 'E') {
            navigate('/member/userInfo/entInfo');
          } else {
            modalService.errorAlert('비밀번호가 일치하지 않습니다.');
          }
        })
        .catch(error => {
        });
    } else {
      modalService.errorAlert('비밀번호는 8자 이상 입력해주세요.');
    }
  };

  // 아이디 비밀번호 입력 input 스페이스 금지
  const handleKeyDown = e => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자 정보</h2>
      </div>

      <h3 className="content-tit">비밀번호 확인</h3>
      <p className="text-gray-70">
        사용자 정보페이지 진입을 위해 비밀번호를 확인합니다.
      </p>

      <div className="txt-box bg-white gap-md">
        <fieldset>
          <legend>비밀번호 확인 폼</legend>
          <div className="form-group">
            <div className="form-tit">
              <label htmlFor="userPswd">비밀번호</label>
            </div>
            <div className="form-conts">
              <div className="input-group">
                <input
                  type="password"
                  id="userPswd"
                  className="form-control"
                  value={formData.userPswd || ''}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown} // 아이디 스페이스바 금지
                  maxLength={20}
                  aria-labelledby="userPswd"
                />

                <button
                  type="button"
                  className="btn secondary"
                  onClick={() => {
                    userInfoPswdChk();
                  }}
                >
                  확인
                </button>
              </div>
            </div>
            {/*  <p className="text-point">유효성 검사 텍스트 유효성 검사 텍스트 유효성 검사 텍스트</p> */}
          </div>
        </fieldset>
      </div>
    </>
  );
};

export default UserInfoPswdChk;
